<template lang="pug">
#v-app.app
  header.app__header: v-header
  section.app__description: v-description
  section.app__reward: v-reward
  a.app__start(v-scroll-to='"#quiz"', href='#quiz') 開始檢測
  section.app__quiz(id='quiz'): v-quiz
  section.app__form: v-form
  footer.app__footer: v-copyright
</template>

<script>
import VHeader from '@/components/Header.vue'
import VDescription from '@/components/Description.vue'
import VReward from '@/components/Reward.vue'
import VQuiz from '@/components/Quiz.vue'
import VForm from '@/components/Form.vue'
import VCopyright from '@/components/Copyright.vue'

export default {
  name: 'App',
  components: {
    VHeader,
    VDescription,
    VReward,
    VQuiz,
    VForm,
    VCopyright,
  },
  created() {
    $(window).resize(() => this.$store.commit('checkMobile')).resize()
  },
}
</script>

<style lang="sass" scoped>
.app
  &__header
    +background(url(~@/assets/header-bg.png))
  &__reward
    background-color: #EDECEE
    &::before
      border-left: 100vw solid transparent
      border-top: 88px solid white
      content: ''
      display: block
    &::after
      border-right: 100vw solid transparent
      border-bottom: 88px solid white
      content: ''
      display: block
  &__start
    +flexbox(center, center)
    +font(28px, white, null, 3px, 500)
    +size(230px, 80px)
    background-color: #E50029
    margin-bottom: 130px
    margin-left: auto
    margin-right: auto
    &:hover
      text-decoration: none
  &__form
    background-color: #EDECEE

@media (max-width: 991px)
  .app
    &__header
      background-image: url(~@/assets/m-header-bg.png)
    &__reward
      &::before
        border-top: 28px solid white
      &::after
        border-bottom: 28px solid white
    &__start
      +font(18px, null, null, 2.69px)
      +size(170px, 50px)
      margin-bottom: 70px
      margin-top: 20px
</style>
